<!-- this is injected into the map svg -->
<defs>
    <pattern id='striped'
             patternUnits='userSpaceOnUse'
             width='20'
             height='20'
             patternTransform='scale(1) rotate(135)'>
        <rect x='0' y='0' width='100%' height='100%' fill='transparent'/>
        <path d='M0 10h20z' stroke-width='4' stroke='hsla(182, 62%, 80%, 1)' fill='none'/>
    </pattern>

    <pattern id="dotted" patternUnits="userSpaceOnUse" width="40" height="40" patternTransform="scale(0.5) rotate(0)">
			<rect x="0" y="0" width="100%" height="100%" fill="transparent" />
			<path d="M40 45a5 5 0 110-10 5 5 0 010 10zM0 45a5 5 0 110-10 5 5 0 010 10zM0 5A5 5 0 110-5 5 5 0 010 5zm40 0a5 5 0 110-10 5 5 0 010 10z" stroke-width="1" stroke="none" fill="hsla(182, 62%, 80%, 1)" />
			<path d="M20 25a5 5 0 110-10 5 5 0 010 10z" stroke-width="1" stroke="none" fill="hsla(182, 62%, 80%, 1)" />
		</pattern>
</defs>
